module.exports = __webpack_public_path__ + "static/media/092.eac91649.JPG";